import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
  class: "backgroundgrid"
};
const _hoisted_2 = {
  id: "header",
  class: "grid-contentheader bg-header"
};
const _hoisted_3 = {
  class: "nav-container"
};
const _hoisted_4 = {
  class: "logo-section"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  key: 0,
  class: "title"
};
const _hoisted_7 = {
  class: "search-section"
};
const _hoisted_8 = {
  class: "value"
};
const _hoisted_9 = {
  class: "searchlink"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  style: {
    "padding": "0",
    "margin": "2px 0"
  }
};
const _hoisted_12 = {
  class: "link"
};
const _hoisted_13 = {
  class: "menu-section"
};
const _hoisted_14 = {
  style: {
    "height": "100vh",
    "padding": "20px",
    "backdrop-filter": "blur(10px)",
    "background-color": "rgba(99,99,99,0.5)"
  }
};
const _hoisted_15 = {
  style: {
    "margin": "50px 0 0 0"
  }
};
const _hoisted_16 = {
  class: "sidebar-title"
};
const _hoisted_17 = {
  style: {
    "width": "85%",
    "margin": "0 auto"
  }
};
const _hoisted_18 = {
  class: "mb-2 flex items-center text-sm"
};
const _hoisted_19 = {
  style: {
    "margin": "50px 0 0 0"
  }
};
const _hoisted_20 = {
  class: "sidebar-title"
};
const _hoisted_21 = {
  style: {
    "width": "85%",
    "margin": "0 auto"
  }
};
const _hoisted_22 = {
  style: {
    "margin": "50px 0 0 0"
  }
};
const _hoisted_23 = {
  class: "sidebar-title"
};
const _hoisted_24 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_25 = {
  class: "grid-content bg-purple-light",
  style: {
    "box-shadow": "0px 0px 20px rgba(0, 0, 0, 0.5)"
  }
};
const _hoisted_26 = {
  id: "Footer",
  class: "grid-contentheader bg-header"
};
const _hoisted_27 = {
  class: "copyright-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_autocomplete = _resolveComponent("el-autocomplete");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _component_el_backtop = _resolveComponent("el-backtop");
  return _openBlock(), _createElementBlock("div", null, [_cache[19] || (_cache[19] = _createElementVNode("link", {
    rel: "stylesheet",
    href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
  }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
    gutter: 0,
    justify: "space-between"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      xs: 0,
      sm: 0,
      md: 1,
      lg: 1,
      xl: 4
    }), _createVNode(_component_el_col, {
      xs: 24,
      sm: 24,
      md: 22,
      lg: 22,
      xl: 16
    }, {
      default: _withCtx(() => [_createElementVNode("nav", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
        href: _ctx.logoHref
      }, _cache[7] || (_cache[7] = [_createElementVNode("img", {
        class: "logo-img",
        src: "https://www.rhino3d.com/static-media/docs/grasshopper/icons/ghicon_en.svg"
      }, null, -1)]), 8, _hoisted_5), _ctx.title !== '' ? (_openBlock(), _createElementBlock("h2", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.title) + " ", 1), _cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "beta-tag"
      }, "beta", -1))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_autocomplete, {
        "popper-class": "el-autocomplete-suggestion",
        "popper-append-to-body": false,
        class: "input-with-select",
        modelValue: _ctx.state,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.state = $event),
        "fetch-suggestions": _ctx.querySearch,
        placeholder: "Please enter the component name to search.",
        "suffix-icon": "el-icon-search",
        "trigger-on-focus": false,
        clearable: false,
        size: _ctx.isMobile ? 'large' : 'medium',
        onSelect: _ctx.handleSelect
      }, {
        default: _withCtx(({
          item
        }) => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          class: "searchimg",
          src: item.icon
        }, null, 8, _hoisted_10), _createElementVNode("h4", _hoisted_11, _toDisplayString(item.value), 1)]), _createElementVNode("span", _hoisted_12, [_createElementVNode("b", null, _toDisplayString(item.category), 1), _createTextVNode(" > " + _toDisplayString(item.sub_category), 1)]), _createVNode(_component_el_divider, {
          style: {
            "margin": "10px 0"
          }
        })])]),
        _: 1
      }, 8, ["modelValue", "fetch-suggestions", "size", "onSelect"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: "menubutton",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.drawer = true)
      }, [_createVNode(_component_el_icon, {
        class: "el-icon-s-operation",
        size: 40,
        color: "#434343"
      })])])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      xs: 0,
      sm: 0,
      md: 1,
      lg: 1,
      xl: 4
    })]),
    _: 1
  }), _createVNode(_component_el_drawer, {
    modelValue: _ctx.drawer,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.drawer = $event),
    "with-header": false,
    "lock-scroll": true,
    modal: true,
    size: "350px",
    "append-to-body": false,
    "show-close": false,
    "custom-class": "menudrawer",
    direction: "rtl"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_icon, {
        class: "fa fa-database",
        size: 18,
        color: "#FFFFFF",
        "aria-hidden": "true"
      }), _cache[9] || (_cache[9] = _createElementVNode("span", null, "Rhino Version", -1))]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_radio_group, {
        modelValue: _ctx.current_version,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.current_version = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "7",
          size: "large"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("Rhino 7")])),
          _: 1,
          __: [10]
        }), _createVNode(_component_el_radio, {
          label: "8",
          size: "large"
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("Rhino 8")])),
          _: 1,
          __: [11]
        }), _createVNode(_component_el_radio, {
          label: "9",
          size: "large"
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("Rhino 9")])),
          _: 1,
          __: [12]
        })]),
        _: 1
      }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_icon, {
        class: "fa fa-th",
        size: 18,
        color: "#FFFFFF"
      }), _cache[13] || (_cache[13] = _createElementVNode("span", null, "Number of Rows", -1))]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_slider, {
        modelValue: _ctx.rows,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.rows = $event),
        "show-stops": "",
        min: 2,
        max: 6,
        marks: _ctx.marks,
        "show-tooltip": false
      }, null, 8, ["modelValue", "marks"])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_icon, {
        class: "fa fa-filter",
        size: 18,
        color: "#FFFFFF"
      }), _cache[14] || (_cache[14] = _createElementVNode("span", null, "Filter", -1))]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_radio_group, {
        modelValue: _ctx.current_tag,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.current_tag = $event),
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          label: "All"
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, tag => {
          return _openBlock(), _createBlock(_component_el_radio_button, {
            key: tag.id,
            label: tag.name
          }, null, 8, ["label"]);
        }), 128)), _createVNode(_component_el_radio_button, {
          label: "Recent Updates"
        })]),
        _: 1
      }, 8, ["modelValue"])])])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["modelValue"])]), _createVNode(_component_el_row, {
    gutter: 0,
    style: {
      "flex": "1 0 auto"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      xs: 0,
      sm: 0,
      md: 1,
      lg: 1,
      xl: 4
    }, {
      default: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("div", {
        class: "grid-content bg-purple"
      }, null, -1)])),
      _: 1,
      __: [15]
    }), _createVNode(_component_el_col, {
      xs: 24,
      sm: 24,
      md: 22,
      lg: 22,
      xl: 16
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)])]),
      _: 3
    }), _createVNode(_component_el_col, {
      xs: 0,
      sm: 0,
      md: 1,
      lg: 1,
      xl: 4
    }, {
      default: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("div", {
        class: "grid-content bg-purple"
      }, null, -1)])),
      _: 1,
      __: [16]
    })]),
    _: 3
  }), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_row, {
    gutter: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      xs: 0,
      sm: 0,
      md: 1,
      lg: 1,
      xl: 4
    }), _createVNode(_component_el_col, {
      xs: 24,
      sm: 24,
      md: 22,
      lg: 22,
      xl: 16
    }, {
      default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "footer-middle"
      }, [_createElementVNode("a", {
        href: "https://www.facebook.com/McNeelRhinoceros/",
        "aria-label": "Facebook",
        class: "fab fa-facebook",
        style: {
          "padding": "10px",
          "font-size": "30px",
          "text-decoration": "none"
        },
        target: "_blank",
        rel: "noopener noreferrer"
      }), _createElementVNode("a", {
        href: "https://twitter.com/bobmcneel",
        "aria-label": "Twitter",
        class: "fab fa-twitter",
        style: {
          "padding": "10px",
          "font-size": "30px",
          "text-decoration": "none"
        },
        target: "_blank",
        rel: "noopener noreferrer"
      }), _createElementVNode("a", {
        href: "https://www.linkedin.com/groups/75313/",
        "aria-label": "LinkedIn",
        class: "fab fa-linkedin",
        style: {
          "padding": "10px",
          "font-size": "30px",
          "text-decoration": "none"
        },
        target: "_blank",
        rel: "noopener noreferrer"
      }), _createElementVNode("a", {
        href: "https://www.youtube.com/channel/UCFk2HeZDZprti9Sm5LWeMPA",
        "aria-label": "YouTube",
        class: "fab fa-youtube",
        style: {
          "padding": "10px",
          "font-size": "30px",
          "text-decoration": "none"
        },
        target: "_blank",
        rel: "noopener noreferrer"
      }), _createElementVNode("a", {
        href: "https://vimeo.com/rhino",
        "aria-label": "Vimeo",
        class: "fab fa-vimeo",
        style: {
          "padding": "10px",
          "font-size": "30px",
          "text-decoration": "none"
        },
        target: "_blank",
        rel: "noopener noreferrer"
      }), _createElementVNode("a", {
        href: "http://blog.rhino3d.com/",
        class: "icon bloggericon",
        "aria-label": "Blogger",
        target: "_blank",
        rel: "noopener noreferrer"
      }), _createElementVNode("a", {
        href: "https://www.food4rhino.com",
        class: "icon food4rhinoicon",
        "aria-label": "Food4Rhino",
        target: "_blank",
        rel: "noopener noreferrer"
      })], -1)), _createVNode(_component_el_divider, {
        style: {
          "width": "100%",
          "background-color": "#444343",
          "margin": "10px auto"
        }
      }), _createElementVNode("div", _hoisted_27, [_createElementVNode("span", {
        onClick: _cache[6] || (_cache[6] = (...args) => _ctx.openCopyrightLink && _ctx.openCopyrightLink(...args))
      }, " Copyright © 1993-" + _toDisplayString(_ctx.currentYear) + " Robert McNeel & Associates (TLM, Inc.). All Rights Reserved. ", 1)])]),
      _: 1,
      __: [17]
    }), _createVNode(_component_el_col, {
      xs: 0,
      sm: 0,
      md: 1,
      lg: 1,
      xl: 4
    })]),
    _: 1
  })]), _createVNode(_component_el_backtop, {
    bottom: 150,
    right: 100,
    class: "custom-backtop"
  }, {
    default: _withCtx(() => _cache[18] || (_cache[18] = [_createElementVNode("div", {
      class: "backtop-content"
    }, [_createElementVNode("i", {
      class: "el-icon-caret-top"
    }), _createElementVNode("span", null, "TOP")], -1)])),
    _: 1,
    __: [18]
  })])]);
}